<template>
  <header class="mobile-header">
    <button @click="$emit('toggleMenu')" class="mobile-header__menu-btn">
      <i class="bi bi-list"></i>
      <!-- V2T-42 · M2: непросмотренное в «Что нового» (сам пункт — в боковом меню) -->
      <span v-if="whatsNewUnseen" class="mobile-header__dot"></span>
    </button>

    <div class="mobile-header__spacer"></div>

    <div class="mobile-header__actions">
      <button @click="toggleTheme" class="mobile-header__action-btn" :title="darkMode ? $t('theme.switch_to_light') : $t('theme.switch_to_dark')">
        <i :class="darkMode ? 'bi bi-sun-fill' : 'bi bi-moon-fill'"></i>
      </button>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { whatsNewState, whatsNewUnseenCount } from '@/lib/whatsNew';

export default {
  name: 'MobileHeaderComponent',

  emits: ['toggleMenu'],

  data() {
    return { whatsNewState };
  },

  computed: {
    ...mapGetters('app', ['configData', 'darkMode']),
    whatsNewUnseen() {
      void this.whatsNewState.seenId;
      return whatsNewUnseenCount(this.configData, this.$i18n.locale);
    },
  },

  methods: {
    ...mapActions('app', ['toggleDarkMode']),

    toggleTheme() {
      this.toggleDarkMode();
    },
  },
};
</script>

<style scoped>
.mobile-header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  background-color: var(--yt-bg-card, #fff);
  border-bottom: 1px solid var(--yt-border-color, #e5e7eb);
  z-index: 50;
}

.mobile-header__menu-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  border-radius: 8px;
  color: var(--yt-text-primary, #1f2937);
  font-size: 24px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.mobile-header__menu-btn {
  position: relative;
}

.mobile-header__dot {
  position: absolute;
  top: 7px;
  right: 6px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #dc3545;
}

.mobile-header__menu-btn:hover {
  background-color: var(--yt-hover-bg, #f3f4f6);
}

.mobile-header__menu-btn:active {
  background-color: var(--yt-active-bg, #e5e7eb);
}

.mobile-header__spacer {
  flex: 1;
}

.mobile-header__actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-header__action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background-color: var(--yt-bg-tertiary, #f3f4f6);
  border-radius: 8px;
  color: var(--yt-text-secondary, #6b7280);
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-header__action-btn:hover {
  background-color: var(--yt-primary, #4F46E5);
  color: white;
}
</style>
